/**
 * Get credentials from the Cart API.
 *
 * @param {string} root - The root URL.
 * @param {string} cart - The cart/new endpoint.
 * @returns {Promise<any>} - An object containing a salesId and token.
 */
const getNewCart = (root, cart) => {
    return fetch(root + `${cart}?organisationType=1`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    })
        .then(response => {
        if (!response.ok) {
            throw new Error('There was an error creating a new cart.');
        }
        else {
            return response.json();
        }
    });
};
export default getNewCart;
